import { theme, themeCssVars } from "./theme";

export const adminModuleCss = `
  ${themeCssVars}
  color: ${theme.color.textSoft};
  --background: ${theme.color.surface};
  --borderFocusColor: ${theme.color.focus};
  --borderHoverColor: ${theme.border.hover};
  --disabledBackground: ${theme.color.surfaceMuted};
  --disabledColor: ${theme.color.disabledText};
  --inputColor: ${theme.color.text};
  --itemColor: ${theme.color.text};
  --itemHoverBG: ${theme.color.itemHover};
  --itemIsActiveBG: ${theme.color.itemActive};
  --listBackground: ${theme.color.dropdown};
  --multiItemBG: ${theme.color.chipMuted};
  --multiItemColor: ${theme.color.text};
  --placeholderColor: ${theme.color.placeholder};
  --selectedItemColor: ${theme.color.text};
}

#admin-list-table {
  background: ${theme.color.panel} !important;
  border-color: ${theme.border.table} !important;
}

#admin-list-table thead,
#admin-list-table thead th,
#admin-list-table thead .bg-primary {
  background: ${theme.color.tableHead} !important;
  color: ${theme.color.text} !important;
  border-color: ${theme.border.panel} !important;
}

#admin-list-table tbody {
  background: ${theme.color.panel} !important;
  color: ${theme.color.textSoft} !important;
}

#admin-list-table tbody tr,
#admin-list-table tbody tr.odd\\:bg-gray-200,
#admin-list-table tbody tr.even\\:bg-gray-50 {
  background: ${theme.color.tableRow} !important;
  color: ${theme.color.textSoft} !important;
}

#admin-list-table tbody tr:nth-child(odd) td {
  background: ${theme.color.tableRow} !important;
}

#admin-list-table tbody tr:nth-child(even),
#admin-list-table tbody tr:nth-child(even) td {
  background: ${theme.color.tableRowAlt} !important;
}

#admin-list-table tbody tr:hover,
#admin-list-table tbody tr:hover td {
  background: ${theme.color.tableRowHover} !important;
}

#admin-list-table td {
  color: ${theme.color.textSoft} !important;
  border-color: ${theme.border.subtle} !important;
}

#admin-list-table input[type="checkbox"] {
  accent-color: ${theme.color.primary} !important;
}

#admin-list-table input:not([type="checkbox"]),
#admin-list-table select,
#admin-list-table textarea,
.themed .svelte-select,
.fixed input,
.fixed select,
.fixed textarea {
  background: ${theme.color.surface} !important;
  border-color: ${theme.border.default} !important;
  color: ${theme.color.text} !important;
}

#admin-list-table .svelte-select input,
.themed .svelte-select input {
  background: transparent !important;
}

#admin-list-table input:not([type="checkbox"])::placeholder,
#admin-list-table textarea::placeholder,
.themed .svelte-select input::placeholder,
.fixed input::placeholder,
.fixed textarea::placeholder {
  color: ${theme.color.placeholder} !important;
}

.themed,
#admin-list-table .themed,
.themed .svelte-select,
.themed .svelte-select input,
.themed .svelte-select .selected-item,
.themed .svelte-select .multi-item,
.themed .svelte-select-list,
.themed .svelte-select-list .item {
  color: ${theme.color.text} !important;
}

.themed .svelte-select-list,
#admin-list-table .svelte-select-list {
  background: ${theme.color.dropdown} !important;
  border-color: ${theme.border.default} !important;
  color: ${theme.color.text} !important;
}

#admin-list-table .svelte-select-list .item,
#admin-list-table .svelte-select-list .text-sm {
  color: ${theme.color.text} !important;
}

#admin-list-table .svelte-select-list button {
  background: ${theme.color.chip} !important;
  color: ${theme.color.text} !important;
}

.themed .svelte-select-list .item.hover,
.themed .svelte-select-list .item.active,
.themed .svelte-select-list .item:hover,
#admin-list-table .svelte-select-list .item.hover,
#admin-list-table .svelte-select-list .item.active,
#admin-list-table .svelte-select-list .item:hover {
  background: ${theme.color.itemHover} !important;
  color: #ffffff !important;
}

.themed .svelte-select .multi-item {
  background: ${theme.color.chipMuted} !important;
  border-color: ${theme.border.default} !important;
  color: ${theme.color.text} !important;
}

[id^="container-"] button.bg-primary,
[id^="container-"] .bg-primary.border-primary,
[id^="container-"] button[class*="bg-primary"],
#admin-list-table button[class*="bg-primary"],
.fixed button.bg-primary {
  background: ${theme.color.button} !important;
  border-color: ${theme.border.strong} !important;
  color: ${theme.color.text} !important;
}

[id^="container-"] button.bg-primary:hover,
[id^="container-"] button[class*="bg-primary"]:hover,
#admin-list-table button[class*="bg-primary"]:hover,
.fixed button.bg-primary:hover {
  background: ${theme.color.buttonHover} !important;
}

.bg-white,
.bg-gray-50,
.bg-gray-100,
.bg-gray-200,
.bg-zinc-50,
.bg-zinc-100,
div.bg-white.py-3 {
  background: ${theme.color.surface} !important;
}

.bg-zinc-50,
.bg-zinc-100 {
  color: ${theme.color.textSoft} !important;
  border-color: ${theme.border.default} !important;
}

.text-gray-400,
.text-gray-500,
.text-gray-600,
.text-gray-700,
.text-gray-900 {
  color: ${theme.color.textMuted} !important;
}

.fixed.inset-0.bg-slate-500,
.fixed.inset-0.bg-gray-500,
.fixed.inset-0.bg-black\\/30,
.fixed.inset-0.z-50,
.fixed.inset-0.z-\\[999\\],
.fixed.inset-0.z-\\[9999\\],
[id^="container-"] [role="dialog"] {
  background: ${theme.overlay} !important;
}

.fixed.inset-0.z-50 > .bg-white,
.fixed.inset-0.z-\\[999\\] > .bg-white,
.fixed.inset-0.z-\\[9999\\] > .bg-white,
.fixed.inset-0.z-50 .bg-white,
.fixed.inset-0.z-\\[999\\] .bg-white,
.fixed.inset-0.z-\\[9999\\] .bg-white,
[id^="container-"] [role="dialog"] .bg-white,
[id^="container-"] [role="dialog"] .bg-slate-50 {
  background: ${theme.color.panel} !important;
  border-color: ${theme.border.panel} !important;
}

[id^="container-"] [role="dialog"] label,
[id^="container-"] [role="dialog"] span,
[id^="container-"] [role="dialog"] h3 {
  color: ${theme.color.text} !important;
}

nav[aria-label="Pagination"] button {
  background: ${theme.color.tableRow} !important;
  color: ${theme.color.textMuted} !important;
  border-color: ${theme.border.panel} !important;
}

nav[aria-label="Pagination"] button:hover,
nav[aria-label="Pagination"] button:focus,
nav[aria-label="Pagination"] button:focus-visible,
nav[aria-label="Pagination"] button[class*="hover:bg-gray-50"]:hover {
  background: ${theme.color.buttonHover} !important;
  color: ${theme.color.text} !important;
  border-color: ${theme.border.hover} !important;
}

nav[aria-label="Pagination"] button.bg-indigo-50,
nav[aria-label="Pagination"] button[class*="bg-indigo-50"] {
  background: ${theme.color.primary} !important;
  color: #ffffff !important;
  border-color: ${theme.color.focus} !important;
}

nav[aria-label="Pagination"] button.bg-indigo-50:hover,
nav[aria-label="Pagination"] button.bg-indigo-50:focus,
nav[aria-label="Pagination"] button.bg-indigo-50:focus-visible,
nav[aria-label="Pagination"] button[class*="bg-indigo-50"]:hover,
nav[aria-label="Pagination"] button[class*="bg-indigo-50"]:focus,
nav[aria-label="Pagination"] button[class*="bg-indigo-50"]:focus-visible {
  background: ${theme.color.primary} !important;
  color: #ffffff !important;
  border-color: ${theme.color.focus} !important;
}

[role="menuitem"] {
  color: ${theme.color.textSoft} !important;
}

[role="menuitem"]:hover {
  background: ${theme.color.itemHover} !important;
  color: #ffffff !important;
}

#admin-list-table button[class*="hover:bg-slate-300"]:hover,
#admin-list-table button[class*="hover:bg-gray-100"]:hover {
  background: ${theme.color.itemHover} !important;
  color: #ffffff !important;
}

.fixed button.rounded-full {
  background: ${theme.color.chip} !important;
  border-color: ${theme.border.default} !important;
  color: ${theme.color.text} !important;
  box-shadow: none !important;
}

.fixed button.rounded-full:hover {
  background: ${theme.color.buttonHover} !important;
  color: #ffffff !important;
}

.fixed .svelte-select {
  background: ${theme.color.surface} !important;
  border-color: ${theme.border.default} !important;
  color: ${theme.color.text} !important;
}

.fixed .svelte-select input {
  background: transparent !important;
}

.fixed .svelte-select .selected-item,
.fixed .svelte-select .value-container,
.fixed .svelte-select .multi-item {
  color: ${theme.color.text} !important;
}

.fixed .svelte-select-list {
  background: ${theme.color.dropdown} !important;
  border-color: ${theme.border.default} !important;
  color: ${theme.color.text} !important;
}

.fixed .svelte-select-list .item,
.fixed .svelte-select-list .text-sm {
  color: ${theme.color.text} !important;
}

.fixed .svelte-select-list .item.hover,
.fixed .svelte-select-list .item.active,
.fixed .svelte-select-list .item:hover {
  background: ${theme.color.itemHover} !important;
  color: #ffffff !important;
}

.fixed .svelte-select-list button {
  background: ${theme.color.chip} !important;
  color: ${theme.color.text} !important;
}

.jse-main {
  --jse-theme-color: ${theme.color.tableHead};
  --jse-theme-color-highlight: ${theme.color.itemHover};
  --jse-background-color: ${theme.color.surface};
  --jse-text-color: ${theme.color.text};
  --jse-panel-background: ${theme.color.panel};
  --jse-panel-color: ${theme.color.text};
  --jse-panel-background-border: ${theme.border.default};
  --jse-main-border: 1px solid ${theme.border.default};
  --jse-key-color: ${theme.color.focus};
  --jse-value-color: ${theme.color.text};
  --jse-value-color-string: #7ee787;
  --jse-value-color-number: #79c0ff;
  --jse-delimiter-color: ${theme.color.textMuted};
  --jse-selection-background-color: ${theme.color.itemActive};
  --jse-hover-background-color: ${theme.color.itemHover};
  --jse-context-menu-background: ${theme.color.dropdown};
  --jse-context-menu-color: ${theme.color.text};
  background: ${theme.color.surface} !important;
  color: ${theme.color.text} !important;
}

.fixed input[type="date"]::-webkit-calendar-picker-indicator,
.fixed input[type="datetime-local"]::-webkit-calendar-picker-indicator,
#admin-list-table input[type="date"]::-webkit-calendar-picker-indicator,
#admin-list-table input[type="datetime-local"]::-webkit-calendar-picker-indicator {
  filter: invert(0.75);
}

.acelink-gruim-css-sentinel {
`;

export const auditLogCss = `
.audit-log-dark table {
  background: ${theme.color.panel} !important;
  border-color: ${theme.border.table} !important;
}

.audit-log-dark thead,
.audit-log-dark thead th,
.audit-log-dark thead.bg-primary {
  background: ${theme.color.tableHead} !important;
  color: ${theme.color.text} !important;
  border-color: ${theme.border.panel} !important;
}

.audit-log-dark tbody,
.audit-log-dark tbody.bg-white {
  background: ${theme.color.panel} !important;
  color: ${theme.color.textSoft} !important;
}

.audit-log-dark tbody tr,
.audit-log-dark tbody tr:nth-child(odd),
.audit-log-dark tbody tr:nth-child(odd) td {
  background: ${theme.color.tableRow} !important;
  color: ${theme.color.textSoft} !important;
}

.audit-log-dark tbody tr:nth-child(even),
.audit-log-dark tbody tr:nth-child(even) td {
  background: ${theme.color.tableRowAlt} !important;
}

.audit-log-dark tbody tr:hover,
.audit-log-dark tbody tr:hover td {
  background: ${theme.color.tableRowHover} !important;
}

.audit-log-dark td {
  color: ${theme.color.textSoft} !important;
  border-color: ${theme.border.subtle} !important;
}

.audit-log-dark .bg-white,
.audit-log-dark .bg-gray-50,
.audit-log-dark .bg-gray-100,
.audit-log-dark .bg-gray-200 {
  background: ${theme.color.surface} !important;
}

.audit-log-dark .text-gray-400,
.audit-log-dark .text-gray-500,
.audit-log-dark .text-gray-600,
.audit-log-dark .text-gray-700,
.audit-log-dark .text-gray-900,
.audit-log-dark .text-black {
  color: ${theme.color.textMuted} !important;
}

.audit-log-dark nav[aria-label="Pagination"] button {
  background: ${theme.color.tableRow} !important;
  color: ${theme.color.textMuted} !important;
  border-color: ${theme.border.panel} !important;
}

.audit-log-dark nav[aria-label="Pagination"] button:hover,
.audit-log-dark nav[aria-label="Pagination"] button:focus,
.audit-log-dark nav[aria-label="Pagination"] button:focus-visible,
.audit-log-dark nav[aria-label="Pagination"] button[class*="hover:bg-gray-50"]:hover {
  background: ${theme.color.buttonHover} !important;
  color: ${theme.color.text} !important;
  border-color: ${theme.border.hover} !important;
}

.audit-log-dark nav[aria-label="Pagination"] button.bg-indigo-50,
.audit-log-dark nav[aria-label="Pagination"] button[class*="bg-indigo-50"] {
  background: ${theme.color.primary} !important;
  color: #ffffff !important;
  border-color: ${theme.color.focus} !important;
}

.audit-log-dark nav[aria-label="Pagination"] button.bg-indigo-50:hover,
.audit-log-dark nav[aria-label="Pagination"] button.bg-indigo-50:focus,
.audit-log-dark nav[aria-label="Pagination"] button.bg-indigo-50:focus-visible,
.audit-log-dark nav[aria-label="Pagination"] button[class*="bg-indigo-50"]:hover,
.audit-log-dark nav[aria-label="Pagination"] button[class*="bg-indigo-50"]:focus,
.audit-log-dark nav[aria-label="Pagination"] button[class*="bg-indigo-50"]:focus-visible {
  background: ${theme.color.primary} !important;
  color: #ffffff !important;
  border-color: ${theme.color.focus} !important;
}

.audit-log-dark input,
.audit-log-dark select,
.audit-log-dark textarea {
  background: ${theme.color.surface} !important;
  border-color: ${theme.border.default} !important;
  color: ${theme.color.text} !important;
}

.audit-log-dark button.bg-primary,
.audit-log-dark button[class*="bg-primary"] {
  background: ${theme.color.button} !important;
  border-color: ${theme.border.strong} !important;
  color: ${theme.color.text} !important;
}

.audit-log-dark button.bg-primary:hover,
.audit-log-dark button[class*="bg-primary"]:hover {
  background: ${theme.color.buttonHover} !important;
}
`;

export const injectAuditLogCss = () => {
  const id = "acelink-audit-log-skin";
  if (document.getElementById(id)) return;
  const style = document.createElement("style");
  style.id = id;
  style.textContent = auditLogCss;
  document.head.appendChild(style);
};
